import React, { useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Button, Input } from "shared";
import "./CouponInput.scss";

interface CouponInputProps {
  onSubmit?: (coupon: string) => Promise<void>;
}

const CouponInput: React.FC<CouponInputProps> = ({ onSubmit }) => {
  const [isCouponSubmitting, setIsCouponSubmitting] = useState(false);

  const validationSchema = Yup.object().shape({
    coupon: Yup.string().required(" "),
  });

  const handleCouponChange = async (values: any) => {
    setIsCouponSubmitting(true);
    const startTime = Date.now();

    try {
      if (onSubmit) {
        await onSubmit(values.coupon);
      }
    } finally {
      const elapsed = Date.now() - startTime;
      const minDelay = 800;

      if (elapsed < minDelay) {
        await new Promise((resolve) => setTimeout(resolve, minDelay - elapsed));
      }

      setIsCouponSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{ coupon: "" }}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={async (values) => handleCouponChange(values)}
    >
      {({ handleSubmit, setFieldValue, values }) => (
        <Form className="coupon-input">
          <div className="coupon-input__content">
            <Field
              type="text"
              id="coupon"
              name="coupon"
              label={
                <p className="coupon-input__label">
                  Masz kod rabatowy? <b>Wpisz go tutaj ↓</b>
                </p>
              }
              as={Input}
              style={{ textTransform: "uppercase" }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFieldValue("coupon", e.target.value.toUpperCase());
              }}
              value={values.coupon}
            />
            <Button
              className="button--rounded button--black button--stroke coupon-input__button"
              label="Zastosuj"
              onClick={handleSubmit}
              isLoading={isCouponSubmitting}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default CouponInput;
